import {distinctUntilChanged, filter, first} from 'rxjs/operators';
import { Component, OnInit, ViewChild, DoCheck, AfterViewInit, OnDestroy, NgZone, ElementRef,
  Input } from '@angular/core';
  import { Router, NavigationEnd, ActivatedRoute, Params } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState, Actions, Order, LoyaltyConfig, LoyaltyMode, User } from '@core/redux/stores';

import {
  ModalService,
  ConfirmModalService,
  SignOutService,
  OverlayService,
  NavigationService,
  ApiService,
  OfferService,
  GetOrderService,
  SelectPickupService,
  UtilitiesService,
  AutoCompleteService
} from '@core/services';
import { Observable ,  Subscription } from 'rxjs';
import { LoggingService } from '@core/services/logging.service';
import { environment } from '@environments/environment';
import _ from 'lodash';
import { MessageSummary, MessageSummaryLoyalty } from '@app/features/account/messaging/models';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { Constants } from '@app/core/constants/core.constants';
import Radar from 'radar-sdk-js';
import { LocationLandingComponent } from '../../features/location/location-landing/location-landing.component';
declare let QSI: any;


@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['../styles/app-root.styles.less', '../styles/app-header.styles.less']
})
export class AppHeaderComponent implements OnInit, DoCheck, AfterViewInit, OnDestroy {
  @select((appState) => appState.user.firstName) firstName?: Observable<string>;
  @select((appState) => appState.user) userObject: Observable<User>;
  @select((appState) => appState.auth.isLoggedIn) isLoggedIn?: Observable<boolean>;
  @select((appState) => appState.activeOrder) activeOrder: Observable<Order>;

  @ViewChild('navBarButton', { static: false }) navBarButton;
  @ViewChild('navheader', { static: false }) navheader;
  @ViewChild('wabContainer', { static: false }) wabContainer;
  @ViewChild('divTopContent', { static: false }) divTopContent;
  @ViewChild('headerCartButton', { static: false }) headerCartButton;
  @ViewChild('home_search', { static: false }) public home_search: ElementRef;

  @Input() isOrderingHeader: boolean;
  @Input() showCartIcon: boolean;
  @Input() isRewards: boolean;


  protected errorResponseMsg: string;

  protected isSignInRequired: boolean;
  protected isUserSignedIn: boolean;

  private subscriptions = new Subscription();

  public searchInput: UntypedFormControl;
  public onlineOffline: boolean = navigator.onLine;
  public previousUrl: string;
  public currentUrl: string;
  public isCollapsed: boolean;

  private tracing: boolean;

  protected hasActiveOrder: boolean;
  protected numberOfItems: number;
  private sidenav: any;
  private sidenavClasses: string;
  isMenuNotAvailable: boolean;
  private order: Order;
  loyaltyMode: LoyaltyMode;
  public LoyaltyMode = LoyaltyMode;

  constructor(
    private modalService: ModalService,
    private ngRedux: NgRedux<IAppState>,
    private signoutService: SignOutService,
    private confirmModalService: ConfirmModalService,
    private ngZone: NgZone,
    private overlayService: OverlayService,
    private router: Router,
    private apiService: ApiService,
    private navigation: NavigationService,
    private logger: LoggingService,
    private activatedRoute: ActivatedRoute,
    private offerService: OfferService,
    private getOrderService: GetOrderService,
    private selectPickupService: SelectPickupService,
    private rewards: RewardService,
    private autoComplete: AutoCompleteService
  ) {
    this.isCollapsed = true;
    this.isSignInRequired = true;
    this.isOrderingHeader = false;
    this.showCartIcon = false;
    this.hasActiveOrder = false;
    this.numberOfItems = 0;
    this.tracing = this.apiService.getVerboseTracing();
    this.isMenuNotAvailable = false;
    this.loyaltyMode = environment.LOYALTY_MODE;
    this.rewards.loyaltyMode = this.loyaltyMode;
    this.searchInput = new UntypedFormControl(null);
    router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe(e => {
        this.currentUrl = e['url'];
        if (this.currentUrl !== Constants.NO_INTERNET_FRAGMENT) {
          this.previousUrl = this.currentUrl;
        }
      });
  }
  getCartLabel(count): string {
    return count?  `View ${count.toString()} item${count>1 ? 's':''} in my Order` : '';
  }

  ngOnInit() {
    if (!this.isOrderingHeader) {
      // remove the flag  from localstorage, if you are navgating out of order flow
      // This local storage is for,if we are going to choose new item from cart in case of recipe unavailability
      localStorage.removeItem('removeItemFromCart');
    }
    this.isLoggedIn.pipe(distinctUntilChanged()).subscribe(
      (val: boolean) => {
        this.isUserSignedIn = val;
      });

    this.subscriptions.add(
      this.activeOrder.subscribe(
        (data) => {
          this.order = _.cloneDeep(data);
          this.hasActiveOrder = false;
          if (data !== undefined && data !== null) {
            if (data.childRecipes !== undefined && data.childRecipes !== null) {
              this.numberOfItems = 0;
              data.childRecipes.forEach(childrec => {
                this.numberOfItems += childrec.quantity ? childrec.quantity : 1;
              });
              if (this.numberOfItems > 0) {
                this.hasActiveOrder = true;
              }
            }
          }
        }
      )
    );

    this.subscriptions.add(
      this.activatedRoute.queryParams.subscribe(
        (params: Params) => {
          if (params[Constants.MENU_NOT_AVAILABLE]) {
            // For handling Back button from Menu Landing screen
            this.isMenuNotAvailable = true;
          } else {
            this.isMenuNotAvailable = false;
          }
        }
      )
    );
  }

  ngAfterViewInit() {
    if(!this.isOrderingHeader) {
      setTimeout(() => { this.attachAutoComplete(); }, 1);
    }
    this.sidenav = document.getElementsByClassName('mat-sidenav-content')[0];
    this.sidenavClasses = this.sidenav.getAttribute('class');
    if(!this.isOrderingHeader) {
      this.home_search.nativeElement.addEventListener('keyup', this.onEnter.bind(this));
    }

  }

  private onEnter(e = null) {
    if (e.key === 'Enter' || e?.keyCode === 13 || e instanceof PointerEvent || e instanceof MouseEvent) {
      const query = this.home_search?.nativeElement?.value?.trim() ?? '';
      if (query?.length > 0) {
        window.location.href = '//locations.whataburger.com/search.html?q=' + this.home_search?.nativeElement?.value.trim();
      }
      e.stopPropagation();
    }
  }


  attachAutoComplete() {
    this.autoComplete.initializeAutoComplete(this, 'home_search');
    this.subscriptions.add(
      this.autoComplete.autoComplete$.subscribe(
        (address) => {
          if(address?.source instanceof AppHeaderComponent) {
            if(address?.address?.formattedAddress?.trim()?.length) {
              switch (address.address.layer) {
                case 'state':
                  window.location.href = `//locations.whataburger.com/search.html?region=${address.address.stateCode}&country=US&qp=${address.address.formattedAddress.trim()}`;
                break;
                case 'address':
                default:
                  window.location.href  = '//locations.whataburger.com/search.html?q=' + address?.address?.formattedAddress?.trim();
                break;
              }
            }
          }
        },
        error => {
          this.logger.logError(error);
        }
      )
    );
  }

  ngDoCheck() {
    if (this.navBarButton !== undefined && this.navheader !== undefined) {
      if (!this.isCollapsed) {
        this.navBarButton.nativeElement.className = 'pull-right navbar-toggle collapsed';
        this.navheader.nativeElement.className = 'navbar-header header-mobile-view black-bg-color';
        this.sidenav.setAttribute('class', this.sidenavClasses + ' overflow-hidden');
      } else {
        this.navBarButton.nativeElement.className = 'pull-left navbar-toggle collapsed';
        this.navheader.nativeElement.className = 'navbar-header header-mobile-view orange-bg-color';
        this.sidenav.setAttribute('class', this.sidenavClasses);
      }
    }
  }

  closeDrawer() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getBgColor() {
    if (!this.isCollapsed) {
      return '#555';
    } else {
      return '#FE7800';
    }
  }

  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  showSignInModal() {
    this.showModal(this.modalService.getSignInModalSelector());
  }

  showSignupModal() {
    this.showModal(this.modalService.getSignupModalSelector());
  }

  toggleCart() {
    if(environment.features.deliveryFrontOfFlow && !this.order?.pickupPath) {
        this.selectPickupService.showPickupModal(null, null, 'Home');
    } else {
      if (this.getOrderService.isAssumedLocation()) {
        this.router.navigate(['/locations'], { queryParams:
          UtilitiesService.generateQueryParams([Constants.RETURN_URL],[Constants.ORDER_SUMMARY]) });
      } else {
        this.modalService.setFlyoutBody('app-my-order-summary');
        this.modalService.toggleFlyout();
      }
    }
  }

  signOutConfirmation() {
    this.subscriptions.add(this.confirmModalService.btnEvent.pipe(first()).subscribe(
      (data: string) => {
        if (data === 'headersignout') {
          // using a settimeout timer to give a moment for the confirm modal to disappear
          setTimeout(() => { this.signOut(); }, 500);
        } else {
          // close was pressed, need further action is needed
        }
      }
    ));

    this.confirmModalService.show(
      '',
      'Are you sure you want to sign out?',
      '',
      'Yes, Sign Out',
      '',
      'No, Keep Me Signed In',
      true,
      'headersignout'
    );
  }

  signOut() {

    this.ngRedux.dispatch({ type: Actions.USERLOGGEDOUT });
    sessionStorage.clear();
    this.offerService.clearOffers(true);
    this.overlayService.displayOverlay('Thank You! <br> Please come back soon.', '/home');

    // this is the API call to sign out. While we are forcing a signout in the client web code above.
    // this is the call to sign them out from the back end. Still, the above code should remove the
    // authentication token so the user would be forced to sign in to get a new one to do anything
    // requiring that token. If an error occurs from the server we are ignoring it for now and treating
    // it clientside as if the user has logged out.
    this.signoutService.logOut();
  }

  onSubmit(event: any) {
    const query = 'q=' + this.home_search.nativeElement.value;
    window.location.href = 'https://locations.whataburger.com/search.html?' + query;
  }
  selectPickupMethod() {
    if(environment.features.deliveryFrontOfFlow) {
      this.selectPickupService.showPickupModal(null, null,'Header');
    } else {
      this.router.navigate(['/ordering/startorder']);
    }
  }
  goBack() {
    const check = sessionStorage.getItem('editFavorite');
    if (check === 'editFavorite') {
      this.checkForUpdateOrder('account');
    } else if (this.isMenuNotAvailable) {
      // For handling back button from Menu Landing screen
      this.isMenuNotAvailable = false;
      this.router.navigateByUrl('/locations');
    } else {
      this.navigation.goBack();
    }
  }
  navigateToHome() {
    this.clearOfferDataIfOffersNotInCart();
    // this.router
    const check = sessionStorage.getItem('editFavorite');
    if (check === 'editFavorite') {
      this.checkForUpdateOrder('home');
    } else {
      this.router.navigateByUrl('/home');
    }
  }
  /**
   * This method created as part of the bug 26187 which will clear out the leaked offers information.
   */
  clearOfferDataIfOffersNotInCart() {
    this.subscriptions.add(
      this.activeOrder.subscribe(
        (activeOrder) => {
          if (activeOrder && activeOrder.childRecipes ) {
              const offerAdded = activeOrder.childRecipes.find((childRecipe) => childRecipe.isOfferAdded === true);
              if (!offerAdded) {
                this.offerService.clearOffers(true);
              }
          } else {
            this.offerService.clearOffers(true);
          }
        })
    );
  }
  checkForUpdateOrder(navigationurl) {
    this.subscriptions.add(this.confirmModalService.btnEvent.pipe(first()).subscribe(
      (data: string) => {
        if (data === 'Discard') {
          // navigate to account landing once discard the changes
          this.router.navigate([navigationurl]);
          // removing order object when discarding the changes from edit favorite
          this.ngRedux.dispatch({ type: Actions.CLEARORDER });
          sessionStorage.removeItem('editFavorite');
        }
      }
    ));

    this.confirmModalService.show(
      '',
      'Discard your changes?',
      '',
      'Discard',
      '',
      'Cancel',
      true,
      'Discard'
    );
  }
  navigateToAccount() {
    this.router.navigateByUrl('/account');
    this.isCollapsed = true;
  }

  isActive(route: string): string {
    const currentRoute: any = this.router.url.split('/');
    if (currentRoute[1].trim() === route.trim()) {
      return 'active';

    }

    return '';
  }
  rewardsHeaderClick() {
    if(this.isUserSignedIn) {
      this.rewards.getMyConvertedRewards().then(
        success => {
          if (success?.items?.length) {
            this.router.navigate(['/rewards/my-rewards']);
          } else {
            this.router.navigate(['/rewards']);
          }
        }
      ).catch(() => {
        this.router.navigate(['/rewards']);
      });
    } else {
      this.showModal('app-points-tutorial');
    }
  }
}
